<template>
  <div class="body">
    <div class="index1">
      
      <van-button class="enter enter1" plain color="#ffffff" @click="enter(4)">越城区申报入口 &nbsp;&nbsp;&nbsp;<span></span></van-button>
      <p style="width: 100%; font-size: 0.9rem;"><strong>滨海新区：</strong>斗门街道、沥海街道、马山街道、孙端街道</p>
      <van-button class="enter enter2" plain  color="#ffffff" @click="enter(5)">滨海新区申报入口&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</van-button>
      <van-button class="enter enter2" plain  color="#ffffff" @click="enter(6)">柯桥区申报入口&nbsp;&nbsp;&nbsp;</van-button>
      <van-button class="enter enter2" plain  color="#ffffff" @click="enter(7)">上虞区申报入口&nbsp;&nbsp;&nbsp;</van-button>
      <van-button class="enter enter2" plain  color="#ffffff" @click="enter(8)">诸暨市申报入口&nbsp;&nbsp;&nbsp;</van-button>
      <van-button class="enter enter2" plain  color="#ffffff" @click="enter(9)">嵊州市申报入口&nbsp;&nbsp;&nbsp;</van-button>
      <van-button class="enter enter2" plain  color="#ffffff" @click="enter(10)">新昌县申报入口&nbsp;&nbsp;&nbsp;</van-button>

      <!-- <van-uploader class="image-list" :max-size="10 * 1024 *1024" v-model="file" accept="image/*"  :max-count="10" ></van-uploader> -->
    </div>
    <!-- <img v-else style="width: 100%;" src="http://img.shaoxing.com.cn/a/10001/202402/1051c650e4821671e678b04f93d2a5e6.jpeg" alt=""> -->
  </div>
</template>
<script>
// import Vconsole from 'vconsole/dist/vconsole.min.js'
// let vConsole = new Vconsole()

import axios from 'axios'
import { util,mc } from '../../assets/common2.js'
// import { Loading } from 'vant'
export default {
  name: 'HouseIndex',
  props: {
  },
  data () {
    return {
      auth: false,
      loading: true,
      file: []
    }
  },
  components: {

  },
  computed: {
  },
  created: function () {
    if (util.inWechat()&&!this.$route.query.iframe) {
      location.replace('http://m.shaoxing.com.cn/wakeup?url='+encodeURIComponent(location.href.split('#')[0]+'?iframe=1'))
    }
    // console.log(vConsole);
    // this.authHandle()
    mc.userGetInfo((userinfo) => {
      mc.userGetEncryptInfo((data) => {
        
        let redirect = ''
        let url = `https://bbs.sxnews.cn/auth/gettoken2?appid=yn7b289e7a84310970a35f47&userid=${data['data']['userid']}&nickname=${userinfo['data']['nickname']}&timestamp=${data['data']['timestamp']}&sign=${data['data']['signature']}&noncestr=${data['data']['nonce']}&redirect_uri=${redirect}&path=subscribe&state=`
        console.log(url);
      })
      
    })
  },
  mounted: function () {
    
  },
  methods: {
    authHandle() {
      util.Arequest((data) => {
        axios.post(`/encrypt3/form/auth?userid=${data.userid}&fid=${this.fid}`,{token:data.token}).then(res => {
            if (res.data.msg == 'ok') {
              this.auth = true
              this.$merchant = res.data.merchant
              this.loading = false
            } else if (res.data.msg == 'not allow') {
              this.auth = false
              this.loading = false
              // this.$toast('无权限')
            } else {
              this.$toast('网络繁忙\n稍后再进')
            }
          }).catch(() => {
            this.$toast('网络繁忙\n稍后再进')
          })
      })
    },
    enter(fid) {
      if (!mc.isClient()) {
        this.$toast('请在越牛新闻客户端查看')
      } else if(new Date().getTime() < 1727056800000) {
        this.$toast('入口将于23日10点开放')
      } else {
        this.$router.push('/house/'+fid)
      }
      
    }
  },
  watch: {

  }
}
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
/* .main {
  margin-top: 56.3vw;
} */
.body {
  max-width: 480px;
  background-image: url(//res.shaoxing.com.cn/a/10001/202409/14f93ff092ac9b475ff47368d6fcf28b.png);
  background-position: top;
  background-size: 100%;
  background-repeat: no-repeat;
  background-color: #fff4ec;
}
.enter1 {
  margin-top: 60%;
}
.enter {
  width: 60vw;
  height: 14vw;
  max-width: 336px;
  max-height: 77px;
  background-image: url(//res.shaoxing.com.cn/a/10001/202409/c6313dc8cee5985c7348ad800890b661.png);
  background-size: cover;
  border: unset;
  background-color: unset;
  color: #ffffff;
  font-size: 1rem;
  /* margin-bottom: 1rem; */
}
.enter2 {
  margin-top: 0.5rem;
  margin-bottom: 1rem;
}
.index1 {
  margin: auto;
  width: 90%;
  min-height: 100vh;
}
</style>
<style>
html,body {
  height: 100%
}

</style>
